import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

const URL = 'v1/news/feed/';

/**
 * @param {number} pageSize
 * @param {string} [keyword]
 * @param {Record<string, any>} [extraParams]
 */
function callbackFetch(pageSize, keyword, extraParams) {
  return async ({ pageParam = 1 }) => {
    try {
      /** @type {import('./typedefs').Response} */
      const res = await fetcher.get(URL, {
        params: {
          page: pageParam,
          page_size: pageSize,
          ...(keyword ? { q: keyword } : {}),
          ...(extraParams || {}),
        },
      });
      return res.data;
    } catch (err) {
      const resp = err?.response?.data;
      errorLogger('ERROR_API', resp?.err_message || err.message);
      throw resp || err;
    }
  };
}

/**
 * @param {{ pageSize?: number, keyword?: string, params?: Record<string, any> }} args
 */
export default function fetch(args) {
  const { pageSize = 50, keyword, params } = args || {};
  return {
    cb: callbackFetch(pageSize, keyword, params),
    key: [URL, pageSize, keyword, params],
  };
}

export { URL };
